document.addEventListener('DOMContentLoaded', function() {
    const productAnchorLinks = getProductAnchorLinks();
    addEventToProductAnchorLinks(productAnchorLinks);

    showMobileStickyCTA(productAnchorLinks);
});

// Next 3 function realize the scroll to the product by click main CTAs
function getProductAnchorLinks() {
    const anchorId = "#section-page-landing-50-new-scroll";
    return document.querySelectorAll(`a[href="${anchorId}"]`);
}

function addEventToProductAnchorLinks(productAnchorLinks) {
    const productElement = document.getElementById("section-page-landing-50-new-scroll");

    productAnchorLinks.forEach(productAnchorLink => {
        productAnchorLink.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            productElement.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        });
    });
}

// Code for showing sticky CTA on mobile and show/hide this button during the scroll
function showMobileStickyCTA(productAnchorLinks) {
    const mobileStickyCTA = document.querySelector(".main-hero__button-wrapper--mobile-sticky");
    let timer = null;
    const firstSectionHeight = document.querySelector("main .main-hero__section, main .section__hero-banner")?.offsetHeight;

    window.addEventListener("scroll", () => {
        if (timer != null) {
            clearTimeout(timer);
            mobileStickyCTA?.classList.remove("visible");
        }

        timer = setTimeout(function () {
            if (window.scrollY > firstSectionHeight) {
                mobileStickyCTA?.classList.add("visible");
            }

            timer = null;
        }, 500);
    });

    /* Add observer to hide sticky button when product section in viewport and when some productAnchorLink except sticky button in viewport  */
    const productSection = document.getElementById('landing-product') || document.getElementById('section-page-landing-50-new-scroll');
    const productAnchorLinksExceptSticky = Array.from(productAnchorLinks).filter(productAnchorLink => {
        return !productAnchorLink.classList.contains("main-hero__button-wrapper--mobile-sticky");
    });
    let initialEntriesCount = productAnchorLinksExceptSticky.length + (productSection ? 1 : 0);
    if (window.scrollY == 0 && navigator.userAgent.toLowerCase().indexOf('safari/') > -1) initialEntriesCount += 3;  

    if (mobileStickyCTA) {
        const options = { threshold: 0.1 };

        const onEntry = (entries) => {
            entries.forEach(entry => {
                initialEntriesCount = initialEntriesCount - 1;
                //if (initialEntriesCount >= 0) return; // Skip initial entries to avoid flicker
                mobileStickyCTA.classList.toggle('main-hero__button-wrapper--hidden', entry.isIntersecting);
            });
        };

        const observer = new IntersectionObserver(onEntry, options);

        if (productSection) observer.observe(productSection);
        if (productAnchorLinksExceptSticky.length) {
            productAnchorLinksExceptSticky.forEach(button => observer.observe(button));
        }
    }
}